import "./main_header.css";
import { Link } from "react-router-dom";

function MainHeader() {
  return (
    <h1 className="main_logo">
      <Link to="/">
        <span className="front_logo">시니어사랑 </span>
        <span className="end_logo">방문요양센터</span>
      </Link>
    </h1>
  );
}

export default MainHeader;
